import React, { } from 'react'

import BottomNavigation, { BottomNavigationProps } from '@material-ui/core/BottomNavigation'
import { BottomActionItem } from './navigation-items'
import { NotificationsActionItem } from "./NotificationsActionItem"
import { ReactFC } from '../types'
import { Hidden } from '@material-ui/core'
import { IconContext } from "react-icons"
import useTheme from '@material-ui/core/styles/useTheme'
import styled from 'styled-components'
import { CreateBottomNavigationAction } from './CreateBottomNavigationAction'
import { useCreation, } from 'ahooks'


const BottomNavigationStyled = styled(BottomNavigation)`
    && {
        background-color: ${({ theme }) => theme.palette.primary.main};
    }
`

type MainPlacesMenuProps = BottomNavigationProps & {
    component?: typeof BottomNavigationStyled
}

export const MainPlacesMenu: ReactFC<MainPlacesMenuProps> = ({ component, ...props }) => {
    const theme = useTheme()
    const Component = component || BottomNavigationStyled


    const buttons = useCreation(() => {
        return (
            <>
                <BottomActionItem place="" />
                <NotificationsActionItem />
                <CreateBottomNavigationAction />
                <BottomActionItem place="groups" />
                <BottomActionItem place="profile" />
            </>
        )
    }, [])
    return (
        <IconContext.Provider value={{ size: theme.iconSize + "px", color: theme.palette.secondary.main }}>
            <Component showLabels={false} {...props}>
                {buttons}
            </Component>
        </IconContext.Provider>
    )
}

const AppBottomNavigationStyled = styled(Hidden) <{ fixed: boolean }>`
  & .MuiBottomNavigation-root {
    height: ${({ theme }) => theme.bottomNavSize}px;
    position: ${({ fixed }) => fixed ? "fixed" : "absolute"};
    bottom: 0;
    left: 0;
    right: 0;
  }

  && .MuiBottomNavigationAction-root {
    min-width: auto;
  }
`

export const AppBottomNavigation: ReactFC<BottomNavigationProps & { fixed: boolean }> = ({ children, fixed, ...props }) => {
    return (
        <AppBottomNavigationStyled smUp implementation="css" fixed={fixed}>
            <MainPlacesMenu {...props}>{children}</MainPlacesMenu>
        </AppBottomNavigationStyled>
    )
}

export default AppBottomNavigation